'use client';

import * as Sentry from 'utils/errorTracking';

import { Button } from '@startengine/design-system.ui.button';
import Image from 'next/legacy/image';

import { useEffect } from 'react';
import { MainBox, MainText, SubText } from './style';
import { imagePath } from 'utils/helpers';

const RenderError = ({ error }) => {
  useEffect(() => {
    if (error) {
      Sentry.captureException(error);
    }
  }, [error]);

  const handleReload = () => {
    if (typeof window !== 'undefined' && window.location) {
      window.location.reload();
    }
  };

  return (
    <MainBox>
      <Image
        src={`${imagePath}/images/explore/RenderError.png`}
        alt="Render Error"
        height={201}
        width={206}
      />
      <MainText
        sx={{
          mt: '36px',
        }}
      >
        Oops, that doesn&apos;t look right
      </MainText>
      <SubText
        sx={{
          mb: {
            xs: '20px',
            md: '24px',
          },
        }}
      >
        Let&apos;s try again.
      </SubText>
      <Button
        variant="contained"
        onClick={handleReload}
        sx={{
          height: '48px',
          width: '327px',
          backgroundColor: 'black',
        }}
        data-cy="reload-page-button"
        data-testid="reload-page-button"
      >
        Reload Page
      </Button>
    </MainBox>
  );
};

export default RenderError;
